import { useState, useRef, useEffect } from "react";
import { Container, VLine, Tooltip } from "./styles";
import { IItemHistorico } from "../types";
import Moment from "react-moment";
import CardHistorico from "./CardHistorico";
import { getIconForAction } from "./CardHistorico/CardRegistry";

export default function ItemHistorico({ item, lastItem = false, onNavigateToFile, fusoHorario = 'BRT' }: { item: IItemHistorico, lastItem?: boolean, onNavigateToFile?: (fileId: number) => void, fusoHorario?: string }) {
    const acaoParaIcone = item.acao_original || item.acao;
    const { Icon, color } = getIconForAction(acaoParaIcone);
    const [showTooltip, setShowTooltip] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (showTooltip && ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const isMobile = window.innerWidth <= 990;
            
            if (isMobile) {
                const horaElement = ref.current.querySelector('.hora-texto') as HTMLElement;
                if (horaElement) {
                    const horaRect = horaElement.getBoundingClientRect();
                    setPosition({ 
                        top: rect.top - 1, 
                        left: horaRect.left + horaRect.width / 2
                    });
                } else {
                    setPosition({ 
                        top: rect.top - 1, 
                        left: rect.left + rect.width / 2
                    });
                }
            } else {
                setPosition({ 
                    top: rect.top - 1, 
                    left: rect.left + rect.width / 2
                });
            }
        }
    }, [showTooltip]);

    useEffect(() => {
        const handleScroll = () => {
            if (showTooltip && ref.current) {
                const rect = ref.current.getBoundingClientRect();
                const isMobile = window.innerWidth <= 990;
                
                if (isMobile) {
                    const horaElement = ref.current.querySelector('.hora-texto') as HTMLElement;
                    if (horaElement) {
                        const horaRect = horaElement.getBoundingClientRect();
                        setPosition({ 
                            top: rect.top - 8, 
                            left: horaRect.left + horaRect.width / 2
                        });
                    } else {
                        setPosition({ 
                            top: rect.top - 8, 
                            left: rect.left + rect.width / 2
                        });
                    }
                } else {
                    setPosition({ 
                        top: rect.top - 8, 
                        left: rect.left + rect.width / 2
                    });
                }
            }
        };

        window.addEventListener('scroll', handleScroll, true);
        window.addEventListener('resize', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
            window.removeEventListener('resize', handleScroll);
        };
    }, [showTooltip]);

    const formatTimeBRT = (date: string) => {
        const d = new Date(date);
        return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    const formatTimeInTimezone = (date: string, timezone: string) => {
        const d = new Date(date);
        const TIMEZONE_OFFSETS: Record<string, number> = {
            'FNT': -2,
            'BRT': -3,
            'AMT': -4,
            'ACT': -5
        };
        
        const brasiliaOffset = TIMEZONE_OFFSETS['BRT'];
        const targetOffset = TIMEZONE_OFFSETS[timezone] || brasiliaOffset;
        const offsetDifference = targetOffset - brasiliaOffset;
        
        const targetTime = new Date(d);
        targetTime.setHours(targetTime.getHours() + offsetDifference);
        
        return targetTime.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    const getTimezoneName = (tz: string) => {
        const nomes: Record<string, string> = {
            'BRT': 'Brasília',
            'AMT': 'Manaus',
            'ACT': 'Rio Branco',
            'FNT': 'Fernando de Noronha'
        };
        return nomes[tz] || tz;
    };
    
    return (
        <Container>
            <VLine lastItem={lastItem} />
            <div className="items">
                <div 
                    ref={ref}
                    className="data"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <Moment 
                        locale='pt-br' 
                        format="DD/MM/YYYY"
                        className="data-texto"
                    >
                        {item.criado}
                    </Moment>
                    <Moment 
                        locale='pt-br' 
                        format="HH:mm:ss"
                        className="hora-texto"
                    >
                        {item.criado}
                    </Moment>
                    {showTooltip && (
                        <Tooltip style={{ top: `${position.top}px`, left: `${position.left}px` }}>
                            <p><strong>BRT (Brasília):</strong> {formatTimeBRT(item.criado)}</p>
                            {fusoHorario && fusoHorario !== 'BRT' && (
                                <p><strong>{fusoHorario} ({getTimezoneName(fusoHorario)}):</strong> {formatTimeInTimezone(item.criado, fusoHorario)}</p>
                            )}
                        </Tooltip>
                    )}
                </div>
                <div className="icone">
                    <Icon color={color} size={16}/>
                </div>
                <CardHistorico item={item} onNavigateToFile={onNavigateToFile} />
            </div>
        </Container>
    );
}